import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IRoleServiceProviderMachine } from "@/interfaces/api/role-service-provider-machine.interface.ts"

export class RoleServiceProviderMachineRepository extends BaseRepository<IRoleServiceProviderMachine> {
  protected resourcePath = "core/role-service-provider-machines"
}
